import { HTTP } from "./callAPI";

/** Dashboard and Layoud */
export const getPermission = () => HTTP.get("permission");
export const getMenu = () => HTTP.get("menu");
export const getrptyearly = (params) => HTTP.get("rptyearly", { params: params });
export const getInvoiceYearly = (params) => HTTP.get("invyearly", { params: params });
export const getrptyebi = (params) => HTTP.get("rptyebi", { params: params });

/** Authorized */
export const login = (data) => HTTP.post("wlogin", data);
export const getUsers = (params) => HTTP.get("user", { params });
export const getUserProfile = () => HTTP.get("profile");
// export const getNewToken = () => HTTP.get("token", { params: { refresh_token: localStorage.getItem("refresh_token") } }); // in case we want to use refresh token
export const createUser = (data) => HTTP.post("user", data);
export const updateUser = (id, data) => HTTP.put(`user/${id}`, data);
export const updateUserStatus = (data) => HTTP.put("userstatus", data);
export const updatePassword = (id, data) => HTTP.post(`changepwd/${id}`, data);
export const logout = () => HTTP.put("logout");

/** GroupUser */
export const getGroupUsers = (params) => HTTP.get("usergroup", { params });
export const createGroupUser = (data) => HTTP.post("usergroup", data);
export const updateGroupUsers = (id, data) => HTTP.put(`usergroup/${id}`, data);
export const updateGroupUserStatus = (data) => HTTP.put("usergroupstatus", data);

/** Master Data */
export const postSync = (data) => HTTP.post("sync", data);

export const getCustomers = (params) => HTTP.get("customer", { params: params });
export const getCustomerByID = (id) => HTTP.get(`customer/${id}`);
export const changeCustomersStatus = (data) => HTTP.put("customerstatus", data);
export const updateCustomer = (id, data, config) => HTTP.put(`customer/${id}`, data, config);

// export const getBank = (params) => HTTP.get("bank", { params: params });
export const getBanks = (params) => HTTP.get("bank", { params: params });
export const getBankById = (id) => HTTP.get(`bank/${id}`);
export const updateBankStatus = (data) => HTTP.put("bankstatus", data);
export const createBank = (data) => HTTP.post("bank", data);
export const editBank = (id, data) => HTTP.put(`bank/${id}`, data);

export const getBact = (params) => HTTP.get("bacts", { params });
export const createBact = (data) => HTTP.post("bacts", data);
export const getBactById = (id) => HTTP.get(`bacts/${id}`);
export const updateBact = (id, data) => HTTP.put(`bacts/${id}`, data);
export const updateBactStatus = (data) => HTTP.put("bactstatus", data);

export const getInvoiceForm = (params) => HTTP.get("invoiceform", { params: params });
export const createInvoiceForm = (data) => HTTP.post("invoiceform", data);
export const updateInvoiceForm = (id, data) => HTTP.put(`invoiceform/${id}`, data);
export const updateInvoiceFormStatus = (data) => HTTP.put("invformstatus", data);

export const getSaleOrder = (params) => HTTP.get("saleorder", { params: params });
export const updateSaleOrderStatus = (data) => HTTP.put("saleorderstatus", data);

export const getPrice = (data) => HTTP.get("price", { params: data });
export const updatePriceStatus = (data) => HTTP.put("pricestatus", data);

export const getExtPrice = (data) => HTTP.get("extprice", { params: data });
export const getExtPriceById = (id, data) => HTTP.get(`extprice/${id}`, { params: data });
export const createExtPrice = (data) => HTTP.post("extprice", data);
export const updateExtPrice = (id, data) => HTTP.put(`extprice/${id}`, data);
export const deleteExtPrice = (id) => HTTP.delete(`extprice/${id}`);

export const getCurrency = (params) => HTTP.get("currency", { params: params });
export const updateCurrencyStatus = (data) => HTTP.put("currencystatus", data);

export const getPriceUnit = (params) => HTTP.get("priceunit", { params: params });
export const updatePriceUnitStatus = (ids) => HTTP.put("priceunitstatus", { ids: ids });

export const getProduct = (params) => HTTP.get("product", { params: params });
export const updateProductStatus = (data) => HTTP.put("productstatus", data);

export const getProductUnit = (params) => HTTP.get("productunit", { params: params });
export const updateProductUnitStatus = (data) => HTTP.put("productunit", data);

export const getFlight = (params) => HTTP.get("flight", { params: params });
export const updateFlightStatus = (data) => HTTP.put("flight", data);

export const getAircraft = (params) => HTTP.get("aircraft", { params: params });
export const updateAircraftStatus = (data) => HTTP.put("aircraft", data);

export const getVehicle = (params) => HTTP.get("vehicle", { params: params });
export const createVehicle = (data) => HTTP.post("vehicle", data);
export const getVehicleById = (id) => HTTP.get(`vehicle/${id}`);
export const updateVehicle = (id, data) => HTTP.put(`vehicle/${id}`, data);
export const searchVehicleByGroup = (params) => HTTP.get("searchvehicle", { params: params });
export const updateVehicleStatus = (data) => HTTP.put("vehiclestatus", data);

export const getGrpSparepart = (params) => HTTP.get("grp_sparepart", { params: params });
export const createGrpSparepart = (data) => HTTP.post("grp_sparepart", data);
export const updateGrpSparepart = (id, data) => HTTP.put(`grp_sparepart/${id}`, data);
export const deleteGrpSparepart = (id) => HTTP.delete(`grp_sparepart/${id}`);

export const getSparepart = (params) => HTTP.get("sparepart", { params: params });
export const createSparepart = (data) => HTTP.post("sparepart", data);
export const updateSparepart = (id, data) => HTTP.put(`sparepart/${id}`, data);
export const deleteSparepart = (id) => HTTP.delete(`sparepart/${id}`);

export const getInventory = (data) => HTTP.get("inventory", { params: data });
export const getProcess = () => HTTP.get("process");
export const updateInventory = (id, data) => HTTP.put(`inventory/${id}`, data);
export const changeInventoriesStatus = (data) => HTTP.put("inventorystatus", data);

export const getLoadingType = (data) => HTTP.get("loadingtype", { params: data });
export const getSaleType = (data) => HTTP.get("saletype", { params: data });

export const getSaleArea = (data) => HTTP.get("salearea", { params: data });
export const updateSaleAreaStatus = (data) => HTTP.put("salearea", data);

export const getTank = (params) => HTTP.get("tank", { params: params });
export const createTank = (data) => HTTP.post("tank", data);
export const updateTank = (id, data) => HTTP.put(`tank/${id}`, data);
export const updateTankStatus = (data) => HTTP.put("tankstatus", data);

export const getGroupVehicles = () => HTTP.get("groupvehicles");
export const updateGroupVehicleStatus = (data) => HTTP.put("groupvehicles", data);

export const getDriver = (params) => HTTP.get("driver", { params });
export const createDriver = (data) => HTTP.post("driver", data);
export const updateDriver = (id, data) => HTTP.put(`driver/${id}`, data);
export const updateDriverStatus = (data) => HTTP.put("driverstatus", data);

export const getProvider = (params) => HTTP.get("provider", { params });
export const updateProvider = (id, data) => HTTP.put(`provider/${id}`, data);
export const createProvider = (data) => HTTP.post("provider", data);
export const updateProviderStatus = (data) => HTTP.put("providerstatus", data);
// export const deleteProvider = (data) => HTTP.delete("provider", { data: data });

export const getOrganizationData = (config) => HTTP.get("organization", config);
export const updateOrganizationStatus = (data) => HTTP.put("organization", data);

export const getDepartment = (config) => HTTP.get("department", config);
export const createDepartment = (data, config) => HTTP.post("department", data, config);
export const updateDepartment = (id, data, config) => HTTP.put(`department/${id}`, data, config);
export const deleteDepartment = (id) => HTTP.delete(`department/${id}`);
export const updateDepartmentStatus = (data, config) => HTTP.put("departmentstt", data, config);

export const getLTP = (data) => HTTP.get("ltp", { params: data });
export const updateLTPStatus = (data) => HTTP.put("ltp", data);

export const getSTP = (data) => HTTP.get("stp", { params: data });
export const updateSTPStatus = (data) => HTTP.put("stp", data);

export const getAirport = (data, config) => HTTP.get("airport", data, config);
export const createAirport = (data, config) => HTTP.post("airport", data, config);
export const editAirport = (id, data, config) => HTTP.put(`airport/${id}`, data, config);
export const updateAirportStatus = (data, config) => HTTP.put("airport", data, config);
export const deleteAirport = (id) => HTTP.put(`airport/${id}`);

export const getCtmdocs = (params) => HTTP.get("ctmdocs", { params });

export const getAcsreg = (params) => HTTP.get("acsreg", { params });
export const createAcsreg = (data) => HTTP.post("acsreg", data);
export const editAcsreg = (id, data) => HTTP.put(`acsreg/${id}`, data);
export const updateAcsregStatus = (data) => HTTP.put("acsreg", data);

export const getPO = (params) => HTTP.get("po", { params });
export const updatePOStatus = (data) => HTTP.put("po", data);

export const getSubso = (params) => HTTP.get("subso", { params });
export const updateSubso = (id, data) => HTTP.put(`/subso/${id}`, data);

export const getAppId = (params) => HTTP.get("appid", { params });

/** FuelTicket */
export const getFuelTicketMenu = () => HTTP.get("ftsidemenu");
export const getFuelTickets = (params) => HTTP.get("fuelticket", { params: params });
export const getFuelTicket = (id) => HTTP.get(`fuelticket/${id}`);
export const deleteFuelTicket = (id) => HTTP.delete(`fuelticket/${id}`);

export const createAirFT = (data) => HTTP.post("airft", data);
export const replaceAirFT = (id, data, config) => HTTP.put(`airft/${id}`, data, config);

export const createTruckFT = (data) => HTTP.post("truckft", data);
export const replaceTruckFT = (id, data) => HTTP.put(`truckft/${id}`, data);

export const createRefuelerTruckFT = (data) => HTTP.post("rftruckft", data);
export const replaceRefuelerTruckFT = (id, data) => HTTP.put(`rftruckft/${id}`, data);

export const approveFT = (id, data) => HTTP.put(`apvft/${id}`, data);
// export const approveFT2 = (id, data) => HTTP.put(`csgft/${id}`, data);

// export const createFuelBatchTicket = (data) => HTTP.post("ftinv", data);
// export const saveFuelTicketDetail = (id, data) => HTTP.put(`fuelticket/${id}`, data);
// export const getIssFuelTicket = (params) => HTTP.get("issfuelticket", { params: params });
// export const createBatchTicket = (data) => HTTP.post("invoice", data);

/** Invoice */
export const getInvoiceMenu = (params) => HTTP.get("invmenu", { params });
export const getInvoices = (params) => HTTP.get("inv", { params: params });
export const getInvoiceById = (id) => HTTP.get(`inv/${id}`);
export const getInvoicePDF = (id) => HTTP.get(`invpdf/${id}`);
export const getInvoiceZip = (id) => HTTP.get(`invzip/${id}`);

export const createAirInv = (data) => HTTP.post("airinv", data);
export const replaceAirInv = (id, data) => HTTP.put(`airinv/${id}`, data);
export const reCreateAirInv = (id, data) => HTTP.put(`airfinv/${id}`, data);

export const createTruckInvoice = (data) => HTTP.post("truckinv", data);
export const replaceTruckInvoice = (id, data) => HTTP.put(`truckinv/${id}`, data);

export const createShipInv = (data) => HTTP.post("shipinv", data);
export const replaceShipInv = (id, data) => HTTP.put(`shipinv/${id}`, data);

export const createOtherInv = (data) => HTTP.post("otherinv", data);
export const replaceOtherInv = (id, data) => HTTP.put(`otherinv/${id}`, data);

export const adjustInv = (data) => HTTP.post("adjinv", data);
// export const deleteInvoice = (id) => HTTP.delete(`inv/${id}`);

export const getErpInv = (params) => HTTP.get("erpinv", { params: params });
export const getERPInvoiceByID = (id) => HTTP.get(`erpinv/${id}`);
export const sendERPInvoiceByID = (id) => HTTP.put(`erpinv/${id}`);
export const adjustErpInv = (data) => HTTP.post("adjerpinv", data);
export const getERPInvoicePDF = (id) => HTTP.get(`erppdf/${id}`);
export const replaceERPInvoice = (data) => HTTP.post(`rplerpinv`, data);

export const approveInvoice = (id, data, config) => HTTP.put(`inv/${id}`, data, config);

export const getRPTSumTotalInv = (params) => HTTP.get("rptsumtotalinv", { params });
export const getRPTTotalInv = (params) => HTTP.get("rpttotalinv", { params });
export const getRPTTotalInvExport = (config) => HTTP.get("rpttotalinv", config);
export const getRPTYearlyByWH = (params) => HTTP.get("/rptyearlybywh", { params });

/** CI */
export const getCIMenu = (params) => HTTP.get("cimenu", { params });
export const getCI = (params) => HTTP.get("ci", { params: params });
export const getSingleCI = (id) => HTTP.get(`ci/${id}`);
export const createCI = (data) => HTTP.post("ci", data);
export const updateCI = (id, data) => HTTP.put(`ci/${id}`, data);
export const updateCIStatus = (data) => HTTP.put("cistatus", data);
export const deleteCI = (id) => HTTP.delete(`ci/${id}`);

// export const getCICode = (data) => HTTP.get("cicode", { params: data });
export const getCIZip = (id) => HTTP.get(`cizip/${id}`);
export const createCIZip = (id) => HTTP.get(`strcizip/${id}`);

/** Report Export CI from invoices */
export const getRptExpCI = (params) => HTTP.get("rptexpci", { params });

// export const check_ci_code = (code) => HTTP.post("checkcicode", code);
// export const searchInvoice = (data) => HTTP.get("searchinvoice", { params: data });

export const getCIInvoice = (params) => HTTP.get("ciinv", { params });

/** PI */
export const parseXML = (data, config) => HTTP.post("pixml", data, config);
// export const getPI = (config) => HTTP.get("pi", config);
export const getPIMenu = (params) => HTTP.get("pimenu", { params });
export const getPI = (data) => HTTP.get("pi", { params: data });
export const createPI = (data, config) => HTTP.post("pi", data, config);
export const editPI = (id, data) => HTTP.post(`pi/${id}`, data);
export const deletePI = (id) => HTTP.delete(`pi/${id}`);
export const restorePI = (id) => HTTP.put(`pirestore/${id}`);
export const updatePIStatus = (id, ...config) => HTTP.put(`pi/${id}`, ...config);

/** Receipt */
// export const getTcode = () => HTTP.get("tcode");
export const getExtrpt = (params) => HTTP.get("extrpt", { params });
export const getExtrptById = (id) => HTTP.get(`extrpt/${id}`);
export const syncExtrpt = (data) => HTTP.post("extrpt", data);
export const putExtrpt = (id, data) => HTTP.put(`extrpt/${id}`, data);

//data o day co the la id cua ticket, hoac la filter. Neu data la id, thi get ticket theo id, con khong thi get ticket theo filter

export const getRPTPDF = (id, ...data) => HTTP.get(`rptpdf/${id}`, ...data);

export const getImpTickets = (params) => HTTP.get("impreceipt", { params });
export const getImportTicketMenu = (params) => HTTP.get("rptimpmenu", { params });

export const getExpTickets = (params) => HTTP.get("expreceipt", { params });
export const getExportTicketMenu = (params) => HTTP.get("rptexpmenu", { params });

export const getTickets = ({ data, id }) => (!id ? HTTP.get("receipt", { params: data }) : HTTP.get(`receipt/${id}`));
export const createNewTicket = (data) => HTTP.post("receipt", data);
export const editTicket = (id, data) => HTTP.put(`receipt/${id}`, data);
export const deleteTicket = (id) => HTTP.delete(`receipt/${id}`);

export const checkImpReceipt = (id) => HTTP.get(`kt0406/${id}`);

export const approveReceipt = (id, data) => HTTP.put(`rpterp/${id}`, data);
export const splitReceipt = (id, data) => HTTP.put(`rptsplitting/${id}`, data);

export const getKT0401 = (...data) => HTTP.get("kt0401", ...data);
export const saveKT0401 = (id, data) => HTTP.put(`kt0401/${id}`, data);
export const saveKT0406 = (id, data) => HTTP.put(`kt0406/${id}`, data);
export const saveKT0407 = (id, data) => HTTP.put(`kt0407/${id}`, data);

export const getRptReceipt = (config) => HTTP.get("rptreceipt", config);
export const getRPTImpTruck = (params) => HTTP.get("rptimptruck", { params });

/** B5 */
export const getImpB5 = (params) => HTTP.get("b5", { params: { ...params, type: "IMP" } });
export const getExpB5 = (params) => HTTP.get("b5", { params: { ...params, type: "EXP" } });
export const getB5Menu = (params) => HTTP.get("b5smenu", { params });
export const getB5ById = (id) => HTTP.get(`b5/${id}`);
export const createB5 = (data) => HTTP.post("b5", data);
export const updateB5 = (id, data) => HTTP.put(`b5/${id}`, data);
export const approveB5 = (id, data) => HTTP.put(`b5apv/${id}`, data);
export const deleteB5 = (id) => HTTP.delete(`b5/${id}`);
export const getB5Pdf = (id) => HTTP.get(`b5pdf/${id}`);

/** M23 */
export const getM23 = (params) => HTTP.get("m23", { params });
export const getM23ById = (id) => HTTP.get(`m23/${id}`);
export const createM23 = (data) => HTTP.post("m23", data);
export const replaceM23 = (id, data) => HTTP.put(`m23/${id}`, data);
export const approveM23 = (id, data) => HTTP.put(`m23erp/${id}`, data);
export const deleteM23 = (id) => HTTP.delete(`m23/${id}`);

export const getRPTM23Truck = (params) => HTTP.get("rptm23truck", { params });

/** Debt */
export const getErppt = (params) => HTTP.get("erppt", { params: params });
export const getErpptMenu = () => HTTP.get("erpptmenu");
export const getErpptById = (id) => HTTP.get(`erppt/${id}`);
export const deleteErpptCi = (id) => HTTP.delete(`erppt/${id}`);
export const approveErppt = (id, data) => HTTP.put(`erppt/${id}`, data);
export const getRPTErppt = (params) => HTTP.get("rpt_erppt", { params });

export const getDebt = (params) => HTTP.get("debt", { params: params });
export const getDebtMenu = () => HTTP.get("debtmenu");

export const getCustDebt = (params) => HTTP.get("cusdebt", { params: params });
export const getRPTDebt = (params) => HTTP.get("rptdebt", { params });

export const getCrrtdebt = (params) => HTTP.get("crrtdebt", { params: params });
// export const getCrrtdebt = (params) => HTTP.get("crrtdebt", { params: params });

export const getPrepaid = (params) => HTTP.get("prepaid", { params: params });
export const showPrepaid = (id) => HTTP.get(`prepaid/${id}`);
export const notiPrepaid = (data) => HTTP.post("prepaid", data);

export const getPrepaidNoti = (params) => HTTP.get("prepaidnotify", { params: params });

/** Technical */
export const getFuelLogbox = (params) => HTTP.get("fuellogbox", { params: params });

/** System */
export const getSyncTime = (params) => HTTP.get("synctime", { params });
export const updateSyncTime = (id, data) => HTTP.put(`synctime/${id}`, data);

export const getExtapies = (params) => HTTP.get("extapi", { params });
export const updateExtapies = (id, data) => HTTP.put(`extapi/${id}`, data);
export const createExtapies = (data) => HTTP.post("extapi", data);
export const updateExtapiStatus = (data) => HTTP.put("extapistatus", data);

export const getConfig = (params) => HTTP.get("config", { params });
export const saveConfig = (data) => HTTP.post(`config`, data);

export const getLog = (params) => HTTP.get("log", { params });

/** Libs */
export const postConversion = (data) => HTTP.post("conversion", data);
export const checkSaleOrder = (data) => HTTP.get("checksaleorder", { params: data });
export const checkPrice = (data) => HTTP.get("ckhprice", { params: data });
export const getCHKSubso = (params) => HTTP.get("chksubso", { params });

export const checkVCF = (data) => HTTP.post("checkvcf", data);
export const checkWCF = (data) => HTTP.post("checkwcf", data);
export const getFrttime = (data) => HTTP.post("frttime", data);

// export const getAirlineBySO = (params) => HTTP.get("airlinebyso", { params: params });
// export const getItemCost = (params) => HTTP.get("itemcost", { params: params });
// export const getSaleForm = (params) => HTTP.get("saleform", { params });
